export const dorotaKuffel = {
    'mydrId': 'dorotakuffel',
    'firstName': 'Dorota',
    'lastName': 'Kuffel',
    'profession': 'Psychoterapeuta osób dorosłych oraz starszej młodzieży, w trakcie certyfikacji',
    'avatar': 'dorota-kuffel.webp',
    'slug': 'psycholog-psychoterapeuta-dorota-kuffel',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'children'],
        ['psychoterapy', 'pair'],
        // ['group', 'developmentGroupGestalt'],
    ]
}